export default class None {
    constructor() {
        this.number = 0;
        this.label = 'Ingen';
        this.image_name = 'none';
        this.id = 'frame-' + this.image_name;
        this.path = '/wp-content/themes/orchid-store-kc/assets/dist/img/frame/';
        this.extension = '.png';
        this.src =  this.path + this.image_name + this.extension;
        this.paperOuterPadding = 0;
        this.addFrameShadow = true;
        this.frameCount = 1;
    }
}
